<template>
  <div class="mirror">
    <div
      class="wrap"
      :style="{
        width: width ? width + 'px' : 'auto',
        height: height ? height + 'px' : 'auto',
      }"
    >
      <div
        class="mirror__truth"
        ref="truth"
        @mousemove="move"
        @mouseenter="showMagnify"
        @mouseleave="hideMagnify"
      >
        <div
          class="mask"
          ref="mask"
          v-show="showMask"
          :style="{
            width: computedWidth / 2 + 'px',
            height: computedHeight / 2 + 'px',
            left: maskPosition.x + 'px',
            top: maskPosition.y + 'px',
          }"
        ></div>
        <v-lazy-img :src="thumbnail" :data-url="url" @load="imgLoad" ref="img"></v-lazy-img>
      </div>
      <div
        class="virtual"
        ref="virtual"
        v-show="isShowVirtual"
        :style="{
          width: computedWidth + 'px',
          height: computedHeight + 'px',
          left: bodyPosition && bodyPosition.x + 'px',
          top: bodyPosition && bodyPosition.y + 'px',
        }"
      >
        <div
          class="big"
          ref="bigPic"
          :style="{
            position: 'absolute',
            width: 2 * computedWidth + 'px',
            height: 2 * computedHeight + 'px',
            backgroundSize: '100% 100%',
            backgroundImage: `url(${bigUrl || url})`,
            left: percent.x,
            top: percent.y,
          }"
        ></div>
      </div>
    </div>
    <!-- 
    <ul class="picList" :style="{ width: computedWidth +'px' }">
      <li
        v-for="(item, index) in picList"
        :class="{ now: index == picIndex }"
        :data-index="index"
        :key="item"
        @mouseenter="changeIndex"
      >
        <img :src="item" />
      </li>
    </ul> -->
  </div>
</template>
<script>
//import LazyImg from '../LazyImg.vue';
export default {
  // components: { LazyImg },
  props: {
    thumbnail: {
      type: String,
      default: null,
    },
    //   原始图
    url: {
      type: String,
      require: true,
    },
    //高清图 若无使用原始图
    bigUrl: {
      type: String,
    },
    //宽度,若无使用图片本身宽度
    width: {
      type: [Number, String],
    },
    height: {
      type: [Number, String],
    },
    picList: {
      type: [Array],
    },
    //是否将放大模块移至Body下
    appendToBody: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      picIndex: 0,
      isShowVirtual: false,
      showMask: false,
      maskPosition: {},
      percent: {},
      bodyPosition: {},
      computedWidth: 0,
      computedHeight: 0,
    };
  },
  mounted() {
    window.addEventListener("resize", this.resize, false);
    if (this.appendToBody) {
      document.body.appendChild(this.$refs.virtual);
    }
  },
  beforeDestroy(){
    window.removeEventListener("resize", this.resize, false);
  },
  methods: {
    resize() {
      let img = this.$refs.img;
      // this.computedWidth = img.offsetWidth;
      // this.computedHeight = img.offsetHeight;
      this.imgLoad()
    },
    imgLoad(e) {
      const img = this.$refs.img;
      
      this.computedWidth = img.$el.offsetWidth;
      this.computedHeight = img.$el.offsetHeight;
      this.$emit('load')

      // e.path 在safari浏览器中，不能识别
      // this.computedWidth = e.path[0].clientWidth;
      // this.computedHeight = e.path[0].clientHeight;
    },
    getScrollOffsets(w) {
      // 计算文档被卷上去的高度
      w = w || window;
      //除了IE8以及更早的版本，其它浏览器都能用
      if (w.pageXOffset != null) {
        return { x: w.pageXOffset, y: w.pageYOffset };
      }
      //对标准模式下的IE或任何浏览器
      var d = w.document;
      if (document.compatMode == "CSS1Compat") {
        return {
          x: d.documentElement.scrollLeft,
          y: d.documentElement.scrollTop,
        };
      }
      //对怪异模式下的浏览器
      return { x: d.body.scrollLeft, y: d.body.scrollTop };
    },
    computedOffset(obj, prop) {
      //计算元素到文档可见顶部的绝对位置
      return parseInt(obj.getBoundingClientRect()[prop]);
      //计算元素到body的绝对位置
      //   if (obj == document.body || obj.offsetParent == document.body) {
      //     return parseInt(obj[prop]);
      //   }
      //   //   递归计算出元素直到父元素是body时
      //   return parseInt(obj[prop]) + this.computedOffset(obj.offsetParent, prop);
    },
    changeIndex(e) {
      this.picIndex = e.target.dataset.index;
    },
    showMagnify(e) {
      this.showMask = true;
      this.isShowVirtual = true;
    },
    hideMagnify() {
      this.isShowVirtual = false;
      this.showMask = false;
    },

    computePosition(e) {
      let x = e.pageX,
        y = e.pageY;
      let mask = this.$refs.mask;
      let truth = this.$refs.truth;
      let virtual = this.$refs.virtual;
      let bigPic = this.$refs.bigPic;
      let truthOffsetLeft = this.computedOffset(truth, "left");
      let truthOffsetTop = this.computedOffset(truth, "top");
      //   let truthOffsetLeft = this.computedOffset(truth, "offsetLeft");
      //   let truthOffsetTop = this.computedOffset(truth, "offsetTop");
      x = x - truthOffsetLeft - mask.offsetWidth / 2;
      //由于被改为计算元素到文档可见顶部的绝对位置 所以还需要加上文档被卷上去的高度
      y =
        y -
        (truthOffsetTop + this.getScrollOffsets().y) -
        mask.offsetHeight / 2;
      //若放大区域被移至body下则重新定位
      if (this.appendToBody) {
        this.bodyPosition = {
          x: truthOffsetLeft + this.computedWidth + 10,
          y: truthOffsetTop + this.getScrollOffsets().y,
        };
      }
      if (x <= 0) {
        x = 0;
      } else if (x > truth.offsetWidth - mask.offsetWidth) {
        x = truth.offsetWidth / 2;
      }

      if (y <= 0) {
        y = 0;
      } else if (y > truth.offsetHeight - mask.offsetHeight) {
        y = truth.offsetHeight / 2;
      }

      this.maskPosition = {
        x,
        y,
      };

      //计算比例

      this.percent = {
        x:
          (-x / (truth.offsetWidth - mask.offsetWidth)) *
            (bigPic.offsetWidth - virtual.offsetWidth) +
          "px",
        y:
          (-y / (truth.offsetHeight - mask.offsetHeight)) *
            (bigPic.offsetHeight - virtual.offsetHeight) +
          "px",
      };
    },
    move(e) {
      this.computePosition(e);
    },
  },
};
</script>
<style lang="scss" scoped>
.now {
  border-color: cyan !important;
}
.mirror {
  width: auto;
  display: inline-block;
  .wrap {
    display: inline-block;
    user-select: none;
    // margin-bottom: 20px;
    position: relative;
    background-color: #fff;
    // border: 1px solid gray;
    box-sizing: border-box;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
    .mask {
      position: absolute;
      background-image: url("~@/images/T12pdtXaldXXXXXXXX-2-2.png");
      background-repeat: repeat;
      cursor: move;
    }
  }
  &__truth {
    width: auto;
    height: auto;
    display: inline-block;
  }
  .picList {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    li {
      width: 50px;
      height: 50px;
      margin: 5px;
      border: 1px solid transparent;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .picList:after {
    content: "";
    flex: auto;
  }
}
.virtual {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
  left: calc(100% + 10px);
  top: 0;
  z-index: 100;
  background-repeat: no-repeat;
}
</style>